<div class="page-wrapper">
  <!-- Page Header -->
  <div class="page-header">
    <div class="container">
      <h1>Find a Mock Test Centre Near You</h1>
      <p>Experience Real Exam Condition across multiple locations</p>
    </div>
  </div>

  <div class="container">
    <!-- Search and Filter Section -->
    <div class="search-section">
      <div class="search-container">
        <div class="search-box">
          <input 
            type="text" 
            placeholder="Search by town, postcode, or area..."
            [(ngModel)]="searchTerm"
            (input)="onSearch($event)">
          <i class="fas fa-search"></i>
        </div>
        <div class="filter-buttons">
          <button 
            class="filter-btn" 
            [class.active]="activeFilter === 'all'"
            (click)="onFilterChange('all')">
            All Locations
          </button>
          <button 
            class="filter-btn" 
            [class.active]="activeFilter === 'gcse'"
            (click)="onFilterChange('gcse')">
            GCSE
          </button>
          <button 
            class="filter-btn" 
            [class.active]="activeFilter === 'alevel'"
            (click)="onFilterChange('alevel')">
            A-Level
          </button>
          <button 
            class="filter-btn" 
            [class.active]="activeFilter === 'online'"
            (click)="onFilterChange('online')">
            Online
          </button>
        </div>
      </div>
    </div>

   

    <!-- Map and Locations Container -->
    <div class="locations-container">
      <!-- Locations List -->
      <div class="locations-list-wrapper">
        <div class="results-info">
          <span class="results-count">{{ resultsCount }} Results Found</span>
          <select class="sort-dropdown" (change)="onSortChange($event)">
            <option value="distance">Sort by: Distance</option>
            <option value="name-az">Sort by: Name A-Z</option>
            <option value="name-za">Sort by: Name Z-A</option>
          </select>
        </div>

        <div class="locations-list">
          <!-- Location Card -->
          <div 
            class="location-card" 
            *ngFor="let location of filteredLocations"
            [attr.data-location]="location.id">
            <div class="location-image">
              <img [src]="location.image" [alt]="location.town + ' Centre'">
              <span class="location-badge" *ngIf="location.badge">{{ location.badge }}</span>
            </div>
            <div class="location-content">
              <div>
                <div class="location-header">
                  <h3 class="location-title">{{ location.town }}</h3>
                </div>
                <div class="location-details">
                  <div class="detail-item">
                    <i class="fas fa-map-marker-alt"></i>
                    <span>{{ location.address }}, {{ location.town }}, {{ location.postcode }}</span>
                  </div>
                  <div class="detail-item">
                    <i class="fas fa-phone"></i>
                    <span>{{ location.phone }}</span>
                  </div>
                </div>
                <div class="location-services">
                  <span class="service-tag" *ngFor="let service of location.services">
                    {{ service }}
                  </span>
                </div>
              </div>
              <div class="location-footer">
                <a [routerLink]="['/location', location.id]" class="view-details-btn">
                  View Details <i class="fas fa-arrow-right"></i>
                </a>
                <span class="distance" *ngIf="location.distance">{{ location.distance }} miles</span>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div class="empty-state" *ngIf="filteredLocations.length === 0">
            <i class="fas fa-search-location"></i>
            <h3>No Locations Found</h3>
            <p>Try adjusting your search or filter criteria</p>
          </div>
        </div>
      </div>

      <!-- Map -->
      <div class="map-wrapper">
        <div class="map-container">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317181.6447662466!2d0.13826235!3d51.5073509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2sus!4v1234567890"
            allowfullscreen 
            loading="lazy">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</div>